<template>
<div class="new-countdown">
    <RadialProgressBar
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :diameter="44"
        :stroke-width="4"
        :inner-stroke-width="4"
        :inner-stroke-color="'#cccccc'"
        :start-color="'#00008f'"
        :stop-color="'#00008f'"
    >
        <p class="value">{{ completedSteps }}</p>
        <p class="name">Saniye</p>
    </RadialProgressBar>
</div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
    components: {
        RadialProgressBar: RadialProgressBar
    },
    props: {
        steps: {
            type: Number,
            default: 180
        }
    },
    data() {
        return {
            timer: null,
            totalSteps: this.$props.steps,
            completedSteps: this.$props.steps
        }
    },
    mounted() {
        let self = this
        self.timer = setInterval(() => {
            if (self.completedSteps > 0) {
                self.completedSteps--
            } else {
                self.$emit('ended')
                clearInterval(self.timer)
            }
        }, 1000)
    }
}
</script>
